import { APIGet, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

type TGetPayout = {
  id?: string | number;
  type?: string;
};

export async function GetPDFs(params: TGetPayout, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/pdf"), params, useGlobalLoader, token);
}
